export enum EFilterDateAuto {
  None,
  ToDay,
  ToWeek,
  ToMonth
}
